module.exports = __webpack_public_path__ + "media/Agony of the Fallen (Kezara's Castle).40677290.mp3";